module.exports = __webpack_public_path__ + "img/loading.e7aa2d00.svg";